import { ADMIN_API_BASE } from "./adminApiConfig";
import adminRequest from "./adminRequest";
import { AdminParticipantEntry } from "./adminTypes";

export type CodeCheckStatus = "used" | "available" | "not_found";

export interface CodeCheckResponse {
  code: number;
  message: string;
  data: {
    status: CodeCheckStatus;
    entry: AdminParticipantEntry | null;
  } | null;
}

const checkAdminCode = async (
  rawCode: string
): Promise<CodeCheckResponse> => {
  try {
    return await adminRequest<CodeCheckResponse>({
      method: "GET",
      url: `${ADMIN_API_BASE}/api/admin/codes`,
      params: { code: rawCode },
    });
  } catch (error) {
    return { code: 500, message: "Greška", data: null };
  }
};

export default checkAdminCode;
